import * as React from "react";
import { EditRequestsScreen } from "../components/Visits/Request/EditRequestsScreen";
import { AppState } from "../system/AppState";
import { ActivityStateMixin, ActivityStateMixinState } from "./ActivityStateMixin";

export interface EditRequestsActivityProps {
  appState: AppState;
  onBackClick: () => void;
}

export interface EditRequestsActivityState {
  mixin: ActivityStateMixinState;
}

export class EditRequestsActivity extends React.Component<
  EditRequestsActivityProps,
  EditRequestsActivityState
> {
  constructor(props: EditRequestsActivityProps) {
    super(props);

    this.activityStateMixin = new ActivityStateMixin(
      (state) =>
        this.setState((_prevState: EditRequestsActivityState) => ({
          mixin: state,
        })),
      this.props.appState
    );

    this.state = {
      mixin: this.activityStateMixin.initialState(),
    };
  }

  private activityStateMixin: ActivityStateMixin;

  handleRequestClick = () => {
    // TODO api request
  };

  render() {
    return (
      <EditRequestsScreen
        onBackClick={this.props.onBackClick}
        onRequestClick={this.handleRequestClick}
        requests={this.state.mixin.appVisitEditRequestsState}
      />
    );
  }
}
